import { render, staticRenderFns } from "./ManageFriend.vue?vue&type=template&id=58b91a8e&scoped=true&"
import script from "./ManageFriend.vue?vue&type=script&lang=js&"
export * from "./ManageFriend.vue?vue&type=script&lang=js&"
import style0 from "./ManageFriend.vue?vue&type=style&index=0&id=58b91a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b91a8e",
  null
  
)

export default component.exports